<script setup lang="ts">
defineProps<{ title: string; backLabel: string }>();
const emit = defineEmits<{ back: [] }>();
</script>

<template>
  <div class="heading">
    <button type="button" class="heading__back" :aria-label="backLabel" @click="emit('back')">
      <svg viewBox="0 0 448 512" width="16" height="16" aria-hidden="true">
        <path
          fill="currentColor"
          d="M9.4 233.4a32 32 0 0 0 0 45.3l160 160a32 32 0 0 0 45.3-45.3L109.3 288H416a32 32 0 1 0 0-64H109.3l105.4-105.4a32 32 0 0 0-45.3-45.3l-160 160z"
        />
      </svg>
    </button>
    <h2 class="heading__title">{{ title }}</h2>
  </div>
</template>

<style scoped>
.heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.heading__back {
  display: grid;
  place-items: center;
  flex: none;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: var(--surface-alt);
  color: var(--interactive-blue);
}

.heading__back:hover {
  background: var(--border);
}

.heading__title {
  margin: 0;
  font-size: 18px;
  line-height: 1.25;
}
</style>
